export const parseIntegerValue = (value?: string, radix = 10): number | undefined => {
    if (!value) return undefined
    const parsed = parseInt(value, radix)
    return isNaN(parsed) ? undefined : parsed
}
